import styled from '@emotion/styled'

const A = styled.a(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    color: theme.colors.textLink,
    fontFamily: theme.fonts.families.body,
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0.35px',
    lineHeight: '18px',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
    [theme.mediaQueries.maxTablet]: {
      fontSize: '12px',
      letterSpacing: '0.6px',
      lineHeight: '8px',
    },
  })
)

export const ASpan = A.withComponent('span')

export default A
